import { Injectable } from "@angular/core";
import { BackendService } from '../../services/new-http/backend.service';

@Injectable({
    providedIn: 'root',
})
export class ReportIncomeService extends BackendService {
    public get(url: string) {
        return this.reportIncomeApiProvider.get(url);
    }
}
